import React from 'react';

const EmploymentInfoTable = ({ emploi }) => {
  return (
    <div className="mb-4">
      {/* Tableau compact et élégant */}
      <table className="w-full border-collapse border border-gray-300 print:border-gray-400 text-sm bg-white">
        <thead>
          <tr className="bg-gray-100 print:bg-gray-200">
            <th className="border border-gray-300 print:border-gray-400 py-2 px-4 text-left font-bold text-gray-800 uppercase tracking-wide text-xs">
              Classe
            </th>
            <th className="border border-gray-300 print:border-gray-400 py-2 px-4 text-left font-bold text-gray-800 uppercase tracking-wide text-xs">
              Semestre
            </th>
            <th className="border border-gray-300 print:border-gray-400 py-2 px-4 text-left font-bold text-gray-800 uppercase tracking-wide text-xs">
              Filière
            </th>
            <th className="border border-gray-300 print:border-gray-400 py-2 px-4 text-left font-bold text-gray-800 uppercase tracking-wide text-xs">
              Département
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="hover:bg-gray-50">
            <td className="border border-gray-300 print:border-gray-400 py-3 px-4 font-semibold text-gray-900">
              {emploi.classe?.libelle || 'Non spécifiée'}
            </td>
            <td className="border border-gray-300 print:border-gray-400 py-3 px-4 font-semibold text-gray-900">
              {emploi.semestre?.libelle || 'Non spécifié'}
            </td>
            <td className="border border-gray-300 print:border-gray-400 py-3 px-4 font-semibold text-gray-900">
              {emploi.classe?.filiere?.libelle || 'Non spécifiée'}
            </td>
            <td className="border border-gray-300 print:border-gray-400 py-3 px-4 font-semibold text-gray-900">
              {emploi.classe?.departement?.libelle || 'Non spécifié'}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EmploymentInfoTable; 